// =============================================================================
// PREVIOUS IMPLEMENTATION — kept verbatim below for reference, intentionally
// inert. Line comments rather than a /* */ block: the original text contains
// comment terminators, which would close a block comment early.
//
// The active implementation follows after this block. Nothing above it is live
// code — it is here so the previous behaviour stays readable in place.
// =============================================================================

// import React from "react";
// import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
// import { Page } from "./types";
// import PageHome from "containers/PageHome/PageHome";
// import Page404 from "containers/Page404/Page404";
// import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
// import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
// import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
// import PayPage from "containers/PayPage/PayPage";
// import useWindowSize from "hooks/useWindowResize";
// import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
// import MyBookings from "containers/MyBookings/index";
// import WishlistPage from "containers/WishlistPage/WishlistPage";
// import FailedPayPage from "containers/PayPage/FailedPayPage";
// import TermsOfUseForTravels from "containers/Privacy/travelPrivacyPolicy";
// import TermsOfUse from "containers/Privacy/privacyPolicy";
// import SignatureComponent from "containers/signaturePage/SignatureComponent";
// import AppLayout from "./AppLayout";
//
// //tenant
// import TenantDashboardPage from "containers/TenantPlatform/TenantDashboardPage";
// import TenantWelcomePage from "containers/TenantPlatform/TenantWelcomePage";
// import TenantVerifyIdentityPage from "containers/TenantPlatform/TenantVerifyIdentityPage";
// import TenantSignContractPage from "containers/TenantPlatform/TenantSignContractPage";
// import TenantReadyForArrivalPage from "containers/TenantPlatform/TenantReadyForArrivalPage";
// import TenantInventoryPage from "containers/TenantPlatform/TenantInventoryPage";
// import TenantInsurancePage from "containers/TenantPlatform/TenantInsurancePage";
// import TenantWelcomeHomePage from "containers/TenantPlatform/TenantWelcomeHomePage";
// import TenantLayout from "./TenantLayout";
//
// export const pages: Page[] = [
//   { path: "/", exact: true, component: ListingStayMapPage },
//   { path: "/pdf", component: SignatureComponent },
//   { path: "/listing-stay", component: ListingStayPage },
//   { path: "/listing-stay-map", component: PageHome },
//   { path: "/listing-stay-detail", component: ListingStayDetailPage },
//   { path: "/checkout", component: CheckOutPage },
//   { path: "/pay-done", component: PayPage },
//   { path: "/my-bookings", component: MyBookings },
//   { path: "/wishlist", component: WishlistPage },
//   { path: "/pay-failed", component: FailedPayPage },
//   { path: "/terms-of-use", component: TermsOfUse },
//   { path: "/travel-terms-of-use", component: TermsOfUseForTravels },
// ];
//
// // Tenant platform pages — rendered inside TenantLayout, not the public site shell.
// export const tenantPages: Page[] = [
//   { path: "/tenant", component: TenantDashboardPage },
// ];
//
// // Onboarding steps carry their own chrome (logo, language, progress) and are
// // reached from the tenant's secure link, so they render bare — no layout.
// export const onboardingPages: Page[] = [
//   { path: "/tenant/welcome", component: TenantWelcomePage },
//   { path: "/tenant/verify-identity", component: TenantVerifyIdentityPage },
//   { path: "/tenant/sign-contract", component: TenantSignContractPage },
//   { path: "/tenant/ready-for-arrival", component: TenantReadyForArrivalPage },
//   { path: "/tenant/inventory", component: TenantInventoryPage },
//   { path: "/tenant/insurance", component: TenantInsurancePage },
//   { path: "/tenant/welcome-home", component: TenantWelcomeHomePage },
// ];
//
// const MyRoutes = () => {
//   let WIN_WIDTH = useWindowSize().width;
//   if (typeof window !== "undefined") {
//     WIN_WIDTH = WIN_WIDTH || window.innerWidth;
//   }
//
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Public site — wrapped in AppLayout (header, search bar, footer) */}
//         <Route
//           element={
//             <AppLayout>
//               <Outlet />
//             </AppLayout>
//           }
//         >
//           {pages.map(({ component: Component, path }) => (
//             <Route key={path} element={<Component />} path={path} />
//           ))}
//         </Route>
//
//         {/* Tenant dashboard — wrapped in TenantLayout */}
//         <Route element={<TenantLayout />}>
//           {tenantPages.map(({ component: Component, path }) => (
//             <Route key={path} element={<Component />} path={path} />
//           ))}
//         </Route>
//
//         {/* Onboarding — bare, no layout wrapper at all */}
//         {onboardingPages.map(({ component: Component, path }) => (
//           <Route key={path} element={<Component />} path={path} />
//         ))}
//
//         <Route path="*" element={<Page404 />} />
//       </Routes>
//     </BrowserRouter>
//   );
// };
//
// export default MyRoutes;

// ==== ACTIVE IMPLEMENTATION ==================================================

import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Page } from "./types";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import useWindowSize from "hooks/useWindowResize";
import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
import MyBookings from "containers/MyBookings/index";
import WishlistPage from "containers/WishlistPage/WishlistPage";
import FailedPayPage from "containers/PayPage/FailedPayPage";
import TermsOfUseForTravels from "containers/Privacy/travelPrivacyPolicy";
import TermsOfUse from "containers/Privacy/privacyPolicy";
import LegalPageLayout from "components/LegalPageLayout/LegalPageLayout";
import SignatureComponent from "containers/signaturePage/SignatureComponent";
import AppLayout from "./AppLayout";

//tenant
import TenantDashboardPage from "containers/TenantPlatform/TenantDashboardPage";
import TenantWelcomePage from "containers/TenantPlatform/TenantWelcomePage";
import TenantVerifyIdentityPage from "containers/TenantPlatform/TenantVerifyIdentityPage";
import TenantSignContractPage from "containers/TenantPlatform/TenantSignContractPage";
import TenantReadyForArrivalPage from "containers/TenantPlatform/TenantReadyForArrivalPage";
import TenantInventoryPage from "containers/TenantPlatform/TenantInventoryPage";
import TenantInsurancePage from "containers/TenantPlatform/TenantInsurancePage";
import TenantWelcomeHomePage from "containers/TenantPlatform/TenantWelcomeHomePage";

export const pages: Page[] = [
  { path: "/", exact: true, component: ListingStayMapPage },
  { path: "/pdf", component: SignatureComponent },
  { path: "/listing-stay", component: ListingStayPage },
  { path: "/listing-stay-map", component: PageHome },
  { path: "/listing-stay-detail", component: ListingStayDetailPage },
  { path: "/checkout", component: CheckOutPage },
  { path: "/pay-done", component: PayPage },
  { path: "/my-bookings", component: MyBookings },
  { path: "/wishlist", component: WishlistPage },
  { path: "/pay-failed", component: FailedPayPage },
  { path: "/legal", component: LegalPageLayout },
  { path: "/terms-of-use", component: TermsOfUse },
  { path: "/travel-terms-of-use", component: TermsOfUseForTravels },
];

// Tenant platform pages. /tenant is the desktop onboarding workspace: it brings
// its own top bar, step rail and stay summary, so it renders bare like the
// onboarding steps below rather than inside TenantLayout — that layout's own
// header would sit on top of the workspace's. TenantLayout is left in the tree
// unused, for whatever tenant screens come after onboarding.
export const tenantPages: Page[] = [
  { path: "/tenant", component: TenantDashboardPage },
];

// Onboarding steps carry their own chrome (logo, language, progress) and are
// reached from the tenant's secure link, so they render bare — no layout.
export const onboardingPages: Page[] = [
  { path: "/tenant/welcome", component: TenantWelcomePage },
  { path: "/tenant/verify-identity", component: TenantVerifyIdentityPage },
  { path: "/tenant/sign-contract", component: TenantSignContractPage },
  { path: "/tenant/ready-for-arrival", component: TenantReadyForArrivalPage },
  { path: "/tenant/inventory", component: TenantInventoryPage },
  { path: "/tenant/insurance", component: TenantInsurancePage },
  { path: "/tenant/welcome-home", component: TenantWelcomeHomePage },
];

const MyRoutes = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public site — wrapped in AppLayout (header, search bar, footer) */}
        <Route
          element={
            <AppLayout>
              <Outlet />
            </AppLayout>
          }
        >
          {pages.map(({ component: Component, path }) => (
            <Route key={path} element={<Component />} path={path} />
          ))}
        </Route>

        {/* Tenant workspace and onboarding — bare, no layout wrapper at all */}
        {[...tenantPages, ...onboardingPages].map(
          ({ component: Component, path }) => (
            <Route key={path} element={<Component />} path={path} />
          )
        )}

        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MyRoutes;
